import { Flex, Box, Heading } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { dateFormatFromRequest } from '../../../services';
import { AvatarWithDefaultIcon } from '../../AvatarWithDefaultIcon';
import { ProfileDataRow } from './ProfileDataRow';

export const ProfileHeader = ({ name, avatar, birthday }: { name?: string; avatar?: string; birthday?: string }) => {
  const { t } = useTranslation();
  return (
    <Flex justifyContent='space-between' alignItems='center' w='100%' mb={6} mt={8}>
      <Box>
        <Heading fontSize='xl'>{name}</Heading>

        <ProfileDataRow label={`${t('input.birth.date.label')}`} message={dateFormatFromRequest(birthday)} mt={3} />
      </Box>

      <AvatarWithDefaultIcon src={avatar} size='xl' />
    </Flex>
  );
};
